import { shuffleArrayElements } from "./Shuffling";

export interface IContentDomino {
  id: number;

  //first half of word
  firstComponent: string;

  //second half of word
  secondComponent: string;
}

/**
 * Creation the dominoes
 */
class DominoConverter {
  /**
   * Check that every word has exactly 2 half and does not contain any error.
   */
  private checkCorrectWords(words: string[]): boolean {
    for (let i: number = 0; i < words.length; i += 1) {
      if (words[i].search(/|/) === -1 || words[i].search(/l/) !== -1)
        return false;
    }
    return true;
  }

  /**Division words by half and creation the massive of dominoes*/
  public createDominoes(words: string[]): Domino[] {
    let newDominoes: Domino[] = [];
    let halfWords: string[][] = [];

    shuffleArrayElements(words);

    if (!this.checkCorrectWords(words))
      throw new Error("Input data (words for dominoes) is not correct!");

    for (let i: number = 0; i < words.length; i += 1) {
      halfWords[i] = words[i].split("|");
    }

    for (let i: number = 0; i < halfWords.length + 1; i += 1) {
      if (i === 0) {
        newDominoes.push(
          new Domino({
            id: i + 1,
            firstComponent: " ",
            secondComponent: halfWords[0][0],
          })
        );
      } else if (i === halfWords.length) {
        newDominoes.push(
          new Domino({
            id: i + 1,
            firstComponent: halfWords[i - 1][1],
            secondComponent: " ",
          })
        );
      } else {
        newDominoes.push(
          new Domino({
            id: i + 1,
            firstComponent: halfWords[i - 1][1],
            secondComponent: halfWords[i][0],
          })
        );
      }
    }
    return newDominoes;
  }
}
export default new DominoConverter();

export class Domino implements IContentDomino {
  id: number;
  firstComponent: string;
  secondComponent: string;

  constructor(domino: {
    id: number;
    firstComponent: string;
    secondComponent: string;
  }) {
    this.id = domino.id;
    this.firstComponent = domino.firstComponent;
    this.secondComponent = domino.secondComponent;
  }
}

export class Slot implements IContentDomino {
  id: number;
  firstComponent: string;
  secondComponent: string;
  isFree: boolean;
  isCorrect: boolean;

  constructor(slot: {
    id: number;
    firstComponent: string;
    secondComponent: string;
  }) {
    this.id = slot.id;
    this.firstComponent = slot.firstComponent;
    this.secondComponent = slot.secondComponent;
    this.isFree = true;
    this.isCorrect = false;
  }
}
